import React from "react";
import cn from "./helpers/cn";
import { TableVariantContext, } from "./TableHead";

interface TableBodyProps extends React.HTMLAttributes<HTMLTableSectionElement> {
  component?: React.ElementType;
  children?: React.ReactNode;
}

const TableBody = React.forwardRef<HTMLTableSectionElement, TableBodyProps>((props, ref) => {
  const { className, component: Component = "tbody", children, ...other } = props;

  return (
    <TableVariantContext.Provider value="body">
      <Component ref={ref} className={cn(className)} {...other}>
        {children}
      </Component>
    </TableVariantContext.Provider>
  );
});

TableBody.displayName = "TableBody";

export default TableBody;
